import { bugsnagClientNotify } from '@bark/bark-core';

export function SellerAvatarFallback() {
	let alt = '';

	$('.user-account-dropdown img.default-avatar').on('error', function () {
		$(this).parent().find('div.default-avatar').removeClass('d-none');
		$(this).parent().find('div.default-avatar').addClass('d-inline-flex');
		$(this).addClass('d-none');
		if (alt !== $(this).prop('alt')) {
			alt = $(this).prop('alt');
			bugsnagClientNotify(new Error('seller-profile-image:failed'), {
				metaData: { 'alt-text': alt, location: 'header' },
				severity: 'info',
			});
		}
	});
	$('.user-account-dropdown img.default-avatar').each(function () {
		if (
			$(this).hasClass('error') ||
			($(this).get()[0].complete &&
				$(this).get()[0].naturalWidth === 0 &&
				$(this).get()[0].naturalHeight === 0)
		) {
			$(this).trigger('error', 'dnr');
		}
	});
}
